module.exports = __webpack_public_path__ + "static/media/hodiny.51e784b4.jpg";